import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';

import { PageTitleStrategy } from './shared/strategies/page-title.strategy';
import { HasRoleGuard } from 'src/api-authorization/has-role.guard';
import { AccessDeniedComponent } from './core/access-denied/access-denied.component';
import { PrivateLayoutComponent } from './core/layouts/private.layout';
import { PublicLayoutComponent } from './core/layouts/public.layout';
import { HelpComponent } from './core/help/help.component';
import { PrivacyComponent } from './core/privacy/privacy.component';
import { MaintenanceModeComponent } from './core/maintenance-mode/maintenance-mode.component';
import { NotInMaintenanceModeGuard } from 'src/api-authorization/not-in-maintenance-mode.guard';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthGuard } from 'src/api-authorization/auth.guard';

const routes: Routes = [
  { path: 'auth', component: MsalRedirectComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthGuard] },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'access-denied',
        component: AccessDeniedComponent,
        title: 'Access Denied'
      },
      {
        path: 'maintenance-mode',
        component: MaintenanceModeComponent,
        title: 'Maintenance Mode'
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
        title: 'Privacy Policy'
      },
      {
        path: 'support',
        component: HelpComponent,
        title: 'Help'
      },
      {
        path: '',
        redirectTo: '/reports',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      {
        path: 'reports',
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
        canActivate: [AuthGuard, NotInMaintenanceModeGuard]
      },
      {
        path: 'help',
        loadChildren: () => import('./help/help.module').then(m => m.HelpModule),
        canActivate: [AuthGuard, NotInMaintenanceModeGuard]
      },
      {
        path: 'administration',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard, NotInMaintenanceModeGuard, HasRoleGuard],
        data: {
          allowedRoles: ['ClientAdministrator', 'Administrator']
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: TitleStrategy,
      useClass: PageTitleStrategy
    }
  ]
})
export class AppRoutingModule { }
